<template>
  <div class="mainClass container py-4">
    <h2 class="settings-title mb-4 text-center">⚙️ Settings</h2>

    <div class="settings-list">
      <!-- Theme Settings -->

        <ChangeTheme />

      <!-- Password Settings -->
      
        <ChangePassword />
      
    </div>
  </div>
</template>

<script>
import ChangePassword from '@/components/SettingPages/ChangePassword.vue';
import ChangeTheme from '@/components/SettingPages/ChangeTheme.vue';

export default {
  components: {
    ChangePassword,
    ChangeTheme
  }
}
</script>

<style scoped lang="scss">
.mainClass {
  max-width: 480px; // mobile-like width
  margin: auto;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.settings-title {
  font-weight: 600;
  font-size: 1.8rem;
}

.settings-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

h2{
 text-shadow: 2px 2px 2px rgb(0, 204, 255);
  
}


</style>
